import { useUkTimeZone } from '../../../../hooks'
import { TableTextCell } from '../TableTextCell'

import { formatDate, getTooltip } from './TableDateCell.utils'

function TableDateCell({ dateFormat, useTodayFormat, value, ...cellProps }) {
  const { locale, timezone } = useUkTimeZone()

  const tooltip = value ? getTooltip(value, locale, timezone) : null

  const formattedDate = formatDate({
    date: value,
    dateFormat,
    locale,
    timezone,
    useTodayFormat,
  })

  return (
    <TableTextCell
      {...cellProps}
      showTooltip={!!tooltip}
      tooltip={tooltip}
      value={value ? formattedDate : null}
    />
  )
}

export default TableDateCell
